import styled from 'styled-components';

import { SWReactIcons } from '@similarweb/icons';

import { Button } from '../../../components/Button';
import { CompanyInfoItem } from '../CompanyInfoItem';

export const StyledCompanyInfoItem = styled(CompanyInfoItem)`
  margin-bottom: 0;
`;

export const StyledCompanyLocaton = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
`;

export const SeeMoreButton = styled(Button)`
  margin-left: auto;
  display: inline-flex;
  justify-content: center;
  align-items: center;

  ${SWReactIcons} {
    margin-left: 4px;
  }
`;
